import React from 'react';
import { formattedDate } from "../../helpers/DateHelpers";

import { Avatar, Tooltip, Comment as CommentAnt, Typography } from "antd";
import './style.scss';
import {useParams, useSearchParams} from "react-router-dom";
import {queryParams} from "../../helpers/UrlHelpers";
const { Text } = Typography;

interface PropsInterface {
  id?: number;
  body: string;
  author: React.ReactNode;
  avatar_url: string | undefined;
  createdAt: string;
  className?: string;
  hidden?: boolean;
  actions?: Array<React.ReactNode>;
  children?: React.ReactNode;
}

const Comment = (
  {
    id,
    body,
    author,
    avatar_url,
    createdAt,
    actions,
    children,
    className,
    hidden
  }: PropsInterface
) => {
  const [searchParams]  = useSearchParams();
  const commentID       = queryParams.getInt(searchParams,'comment_id');
  const date = formattedDate(createdAt);

  return(
    <CommentAnt
      className={`v-comment ${className || ''}${hidden ? ' o-hidden' : ''}`}
      actions={actions}
      author={author}
      avatar={<Avatar shape='square' src={avatar_url} />}
      content={<p><Text mark={commentID === id}>{body}</Text></p>}
      datetime={
        <Tooltip title={date.dateTime}>
          <span className='v-comment--date'>{date.fromNow}</span>
        </Tooltip>
      }
    >
      {children}
    </CommentAnt>
  )
}

export default Comment;
